import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  loadUsersRequested,
  storeUserRequested,
  storeAssignRoleRequested,
  loadSingleCustomerRequested,
} from 'store/users/userSlice';

export function useLoadUsers() {
  const dispatch = useDispatch();

  const onLoadUsers = useCallback(async () => {
    await dispatch(loadUsersRequested({ page: 1, pageSize: 15, userType: 0 }));
  }, [dispatch]);

  useEffect(() => {
    onLoadUsers();
  }, [onLoadUsers]);

  return { onLoadUsers };
}

export function useLoadSingleCustomer() {
  const dispatch = useDispatch();
  const onLoadSingleCustomer = useCallback(async () => {
    await dispatch(loadSingleCustomerRequested({}));
  }, [dispatch]);

  useEffect(() => {
    onLoadSingleCustomer();
  }, [onLoadSingleCustomer]);

  return { onLoadSingleCustomer };
}

export function useStoreUser() {
  const dispatch = useDispatch();

  const onStoreUser = useCallback(
    async (values: any, action: any) => {
      await dispatch(
        storeUserRequested({
          firstname: values?.firstname,
          lastname: values?.lastname,
          email: values?.email,
          password: values?.password,
          mobile: values?.mobile,
          userType: 0,
        })
      );
    },
    [dispatch]
  );

  return { onStoreUser };
}

export function useStoreAssignRole() {
  const dispatch = useDispatch();

  const onStoreAssignRole = useCallback(
    async (values: { userId: number; roleId: number[] }) => {
      const selectedIds = values.roleId?.map((item: any) => item.id);
      await dispatch(
        storeAssignRoleRequested({
          userId: values.userId,
          roleId: selectedIds,
        })
      );
    },
    [dispatch]
  );

  return { onStoreAssignRole };
}
